/** Llamadas HTTP del feature Rutas operacionales. */
import { apiRequest } from "../../lib/api";

export interface RutaRead {
  id: number;
  empresa_id: number;
  sector_id: number;
  codigo: string;
  nombre: string;
  operador_id: number | null;
  dia_lectura: number | null;
  orden_en_sector: number;
  activa: boolean;
  descripcion: string | null;
  created_at: string;
  updated_at: string;
}

export interface RutaConDetalle extends RutaRead {
  sector_nombre: string;
  sector_codigo: string | null;
  operador_nombre: string | null;
  operador_email: string | null;
  cantidad_arranques: number;
  dia_lectura_efectivo: number;
}

export interface ArranqueEnRuta {
  id: number;
  codigo_arranque: string | null;
  direccion: string;
  numero_casa: string | null;
  referencia: string | null;
  orden_ruta: number | null;
  estado: string;
  latitud: number | null;
  longitud: number | null;
  georef_origen: string | null;
}

export interface RutaCreatePayload {
  sector_id: number;
  codigo: string;
  nombre: string;
  operador_id?: number | null;
  dia_lectura?: number | null;
  orden_en_sector?: number;
  descripcion?: string | null;
}

export interface RutaUpdatePayload {
  codigo?: string;
  nombre?: string;
  operador_id?: number | null;
  dia_lectura?: number | null;
  orden_en_sector?: number;
  activa?: boolean;
  descripcion?: string | null;
}

export interface ItemReorden {
  arranque_id: number;
  orden: number;
}

export function listarRutas(opts?: {
  sector_id?: number;
  solo_activas?: boolean;
}): Promise<RutaConDetalle[]> {
  const params = new URLSearchParams();
  if (opts?.sector_id != null) params.set("sector_id", String(opts.sector_id));
  if (opts?.solo_activas) params.set("solo_activas", "true");
  const qs = params.toString();
  return apiRequest<RutaConDetalle[]>(
    `/api/v1/rutas${qs ? `?${qs}` : ""}`,
  );
}

export function obtenerRuta(id: number): Promise<RutaConDetalle> {
  return apiRequest<RutaConDetalle>(`/api/v1/rutas/${id}`);
}

export function crearRuta(p: RutaCreatePayload): Promise<RutaRead> {
  return apiRequest<RutaRead>("/api/v1/rutas", { method: "POST", body: p });
}

export function actualizarRuta(
  id: number,
  p: RutaUpdatePayload,
): Promise<RutaRead> {
  return apiRequest<RutaRead>(`/api/v1/rutas/${id}`, {
    method: "PATCH",
    body: p,
  });
}

export function eliminarRuta(id: number): Promise<void> {
  return apiRequest<void>(`/api/v1/rutas/${id}`, { method: "DELETE" });
}

export function listarArranquesDeRuta(id: number): Promise<ArranqueEnRuta[]> {
  return apiRequest<ArranqueEnRuta[]>(`/api/v1/rutas/${id}/arranques`);
}

export function asignarArranques(
  id: number,
  arranque_ids: number[],
): Promise<RutaRead> {
  return apiRequest<RutaRead>(`/api/v1/rutas/${id}/arranques`, {
    method: "POST",
    body: { arranque_ids },
  });
}

export function reordenarArranques(
  id: number,
  items: ItemReorden[],
): Promise<RutaRead> {
  return apiRequest<RutaRead>(`/api/v1/rutas/${id}/reordenar`, {
    method: "POST",
    body: { items },
  });
}

export function compactarRuta(id: number): Promise<RutaRead> {
  return apiRequest<RutaRead>(`/api/v1/rutas/${id}/compactar`, {
    method: "POST",
  });
}
